
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#42A5B2","d":"M27.779 24.146L20.255 3.474l5.638-2.052 13.162 18.621z"}}),_c('path',{attrs:{"fill":"#62C4C3","d":"M4.799 28.254l45.178-16.443a4 4 0 013.449.342l3.826 2.33a4 4 0 012.736 7.518L28.039 33.629l-21.188.263-2.052-5.638z"}}),_c('path',{attrs:{"fill":"#42A5B2","d":"M5.138 17.489l-3.759 1.368 3.42 9.397 7.518-2.736zM29.148 27.905l7.523 20.673 5.64-2.052-1.888-22.725z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M50.93 14.658l4.7-1.709.683 1.88-4.7 1.708zM44.35 17.05l1.88-.684.683 1.878-1.879.684zM40.592 18.417l1.878-.683.684 1.878-1.879.684zM36.834 19.786l1.879-.683.683 1.878-1.878.684zM33.075 21.154l1.879-.683.683 1.878-1.878.684zM29.316 22.522l1.879-.683.683 1.878-1.878.684zM25.558 23.89l1.878-.683.684 1.878-1.879.684zM21.799 25.258l1.878-.683.684 1.878-1.879.684zM18.04 26.629l1.88-.685.685 1.88-1.88.684zM14.282 27.997l1.879-.685.684 1.88-1.879.684zM36 54H19c-3.309 0-6-2.691-6-6s2.691-6 6-6h7v2h-7c-2.206 0-4 1.794-4 4s1.794 4 4 4h17v2zM38 52h2v2h-2z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M50.5 61H19v-2h31.5c1.379 0 2.5-1.122 2.5-2.5S51.879 54 50.5 54H42v-2h8.5c2.481 0 4.5 2.019 4.5 4.5S52.981 61 50.5 61zM7 59h10v2H7z"}}),_c('circle',{attrs:{"cx":"5","cy":"60","r":"3","fill":"#EFBC2E"}}),_c('circle',{attrs:{"cx":"28","cy":"43","r":"3","fill":"#EFBC2E"}})])
          )
        }
      }
    